import { FC, useCallback, useState } from 'react';
import { WrappedFieldProps } from 'redux-form';
import ToggleButton from '@material-ui/lab/ToggleButton';
import StyledToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { PromoLabel } from 'types';
import { Icon } from 'components/Icon/Icon';
import { ReactComponent as PromoGiftIcon } from 'assets/icons/main-24/gift--24.svg';
import { ReactComponent as PromoPercentIcon } from 'assets/icons/main-24/promo-percent-star--24.svg';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

export interface PromoLogoSelectControlProps {
    value: PromoLabel;
    onChange: (value: PromoLabel) => void;
}

const useStyles = makeStyles(theme => ({
    toggleGroup: {
        display: 'flex',
    },
    togglerButton: {
        flex: 1,
        borderRadius: '20px !important',
        border: '2px solid rgba(15, 24, 37, 0.1)',
        '&:not(:first-child)': {
            borderRadius: theme.shape.borderRadius,
            borderLeft: '2px solid rgba(15, 24, 37, 0.1)',
        },
        '&:first-child': {
            borderRadius: theme.shape.borderRadius,
        },
        '&.Mui-selected': {
            backgroundColor: '#FFFFFF !important',
            borderColor: '#243143',
        },
    },
    grouped: {},
    giftToggler: {
        marginRight: theme.spacing(1),
    },
    percentToggler: {
        marginLeft: '8px !important',
    },
    iconWrapper: {
        borderRadius: theme.spacing(1),
        height: 40,
        width: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    giftIconWrapper: {
        backgroundColor: '#8AE752',
        '& svg': {
            '& path': {
                fill: '#FFFFFF',
            },
        },
    },
}));

export const PromoLogoSelectControl: FC<PromoLogoSelectControlProps> = props => {
    const { onChange, value } = props;

    const classes = useStyles();
    const [view, setView] = useState(value);

    const handleChange = useCallback(
        (event: React.MouseEvent<HTMLElement>, nextView: PromoLabel) => {
            setView(nextView);
            onChange(nextView);
        },
        [setView, onChange],
    );

    return (
        <StyledToggleButtonGroup
            className={classes.toggleGroup}
            orientation="horizontal"
            value={view}
            exclusive
            onChange={handleChange}
        >
            <ToggleButton className={classNames(classes.togglerButton, classes.giftToggler)} value={PromoLabel.GIFT}>
                <div className={classNames(classes.iconWrapper, classes.giftIconWrapper)}>
                    <Icon component={PromoGiftIcon} svgSize={24} size={24} />
                </div>
            </ToggleButton>
            <ToggleButton
                className={classNames(classes.togglerButton, classes.percentToggler)}
                value={PromoLabel.PERCENT}
            >
                <div className={classes.iconWrapper}>
                    <Icon component={PromoPercentIcon} svgSize={40} size={40} />
                </div>
            </ToggleButton>
        </StyledToggleButtonGroup>
    );
};

export const PromoLogoControlField = (props: WrappedFieldProps) => {
    const { input, ...rest } = props;
    return <PromoLogoSelectControl {...rest} {...input} />;
};
